export default __webpack_public_path__ + "static/media/Login-amico.5170cf65.svg";